import { useAppDispatch } from "@/store";
import { adminApi } from "@/store/apis/adminApi";
import { useSignOutMutation } from "@/store/apis/adminApi.enhanced";
import { clearSession } from "@/store/slices/authSlice";

/**
 * Hook de sign-out. Intenta cerrar la sesión en el back, pero limpia
 * el estado local siempre — la usuaria no puede quedar bloqueada por
 * un error de red al salir.
 */
export function useSignOut() {
  const [signOut, state] = useSignOutMutation();
  const dispatch = useAppDispatch();

  const run = async () => {
    try {
      await signOut().unwrap();
    } catch (err) {
      console.warn("[auth] sign-out failed on server, clearing local anyway:", err);
    } finally {
      dispatch(clearSession());
      dispatch(adminApi.util.resetApiState());
    }
  };

  return { signOut: run, isLoading: state.isLoading };
}
